let _tabGroupUid = 0;

/**
 * Both tab-group versions must draw from this one counter: a page may mix them, and
 * per-version counters would issue colliding ids.
 */
export function nextTabGroupId(): string {
    return `sir-tabs-${_tabGroupUid++}`;
}
